// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__23ctr","col":"styles_col__1CUuS"};